import { motion } from "framer-motion";
import { Calipers } from "@/components/site/DecorativeBG";

export default function QualityLab() {
  return (
    <section
      id="quality"
      data-testid="quality-section"
      className="relative py-24 lg:py-32 bg-brand-bg overflow-hidden"
    >
      <Calipers className="top-16 -right-10 lg:right-8 hidden md:block" opacity={0.18} bounce />

      <div className="container-x relative">
        <div className="grid lg:grid-cols-12 gap-12 items-end mb-12">
          <div className="lg:col-span-7">
            <div className="flex items-center gap-3 mb-5">
              <span className="divider-rule" />
              <span className="eyebrow">Quality Control Lab</span>
            </div>
            <h2 className="h-section">
              Quality you can trust —
              <br />
              <span className="text-brand-blue">every part, every process, every time.</span>
            </h2>
          </div>
          <div className="lg:col-span-5 text-brand-text/70 leading-relaxed">
            Our in-house quality lab combines dimensional, metallurgical,
            coating and non-destructive testing — supported by full PPAP / FAI
            documentation and third-party inspection coordination.
          </div>
        </div>

        {/* Quality lab image card */}
        <motion.div
          initial={{ opacity: 0, y: 16 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.2 }}
          transition={{ duration: 0.7 }}
          className="bg-white border border-gray-200 p-3 sm:p-5 lg:p-8 shadow-sm"
        >
          <picture>
            <source srcSet="/quality-lab.webp" type="image/webp" />
            <img
              src="/quality-lab.png"
              alt="Tirupati Quality Lab — Contracer, CMM, TRIMOS Height Gauge, XRF, Coating Thickness, Conductivity, Hardness, Surface Roughness, MPI"
              className="w-full h-auto"
              loading="lazy"
              data-testid="quality-lab-image"
            />
          </picture>
        </motion.div>

        {/* Tagline */}
        <div className="mt-10 text-center">
          <div className="font-heading font-extrabold text-xl lg:text-2xl text-brand-navy italic">
            &ldquo;Quality You Can Trust — Every Part. Every Process. Every Time.&rdquo;
          </div>
        </div>
      </div>
    </section>
  );
}
